import styled from "styled-components"


const Title = styled.div`
    font-weight: bold;
    font-size: 1.2rem;

    @media (max-width:290px){
        font-size: 0.7rem;
    }
`

const Author = styled.div`
    font-size: 0.5rem;
`

export default function MessageContent() {
    return <>
        <Title className="col px-1 px-3 mx-0 py-3">
          <div className="col text-center">关于做好“交院e党建”平台收缴党费的通知!</div>
        </Title>
        <Author className="row pt-0 pb-3 px-1 mx-0">
            <div className="row">
                <div className="col">发布部门：党委组织部（党委统战部、党校）</div>
            </div>
            <div className="row">
                <div className="col">发布时间：2022-02-24</div>
            </div>
        </Author>
        <div className="row px-1 pb-5 mx-0">
            <div className="col">
                各党总支（直属党支部）、各党支部：<br />

                为方便师生党员及时交纳党费，学院“交院e党建”智慧党建平台开通了的党费收缴功能，从本月开始启用 “交院e党建”开展学院党员党费收缴工作，现将有关事项通知如下：<br/>

                一、党费收缴标准及时间<br/>

                根据中共中央组织部《关于中国共产党党费收缴、使用和管理的规定》（中组发【2008】3号）《中共中央组织部办公厅关于进一步规范党费工作的通知》（组电明字【2017】5号），各级党组织准确核定党员党费缴纳标准。全校在岗教职工党员从2022年1月起均须通过“交院e党建”按月线上缴纳党费。全体党员须在每月第一周完成当月党费线上缴纳，第二周各党总支（直属党支部）通过“党费统计”功能检查、核算各支部党员的党费缴纳情况，按支部打印缴费明细，总支书记签字盖章后集中到财务处开具党费票据。<br/>

                二、具体办法及工作要求<br/>

                1.请各支部系统管理员通过“交院e党建”（校内IP:10.100.105.141）电脑端系统登录“党务工作管理”—“党费管理”—“党费缴纳”子模块进行核查，2月底前集中完成本支部“组织信息管理”、 “党员信息管理”模块的维护，确保本支部党组织信息和党员信息准确入库。<br/>

                2.核算2021年度职务、职称晋升的党员以及新入职党员的月缴费标准，及时在系统做出调整。<br/>

                3.线下缴纳党费的渠道仍然保留，离退休党员可采取线下方式。<br/>

                联系人：李文婕，联系电话：025-86115808。<br/>

                特此通知。<br/>

                党委组织部<br/>

                    2022年2月23日<br />
            </div>
        </div>
    </>
}